// must be imported before React and React DOM
// import { scan } from 'react-scan';
import React, { useEffect } from 'react';
import * as core from 'cw-ui-core';
import getDialogFactory from 'src/components/DialogFactory';
import getDrawerFactory from 'src/components/DrawerFactory';
import AppContainer from 'src/app/AppContainer';
import rootReducer from 'src/app/rootReducer';
// import { Log } from 'oidc-client-ts';
import rootSaga from 'src/app/rootSaga';
import { getOidcConfig } from 'src/configs/oidcConfig';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { colors } from 'src/theme/old-theme';
import rootMiddleware from 'src/app/rootMiddleware';
import AppLoader from './components/AppLoader/AppLoader';
import OidcError from './components/OidcError/OidcError';
const MODULE_ID = 'sts-user-management-ui';
export default MODULE_ID;

// Enble debug mode for oidc-client-ts
// Log.setLogger(console);
// Log.setLevel(Log.DEBUG);

const { addMiddleware } = core.dynamicMiddleware;

// inject app reducers async
Object.keys(rootReducer).forEach(key => core.injectReducer(key, rootReducer[key]));

Object.keys(rootMiddleware).forEach(key => addMiddleware(rootMiddleware[key]));

// Run root sagas before app initialization
core.runRootSaga(rootSaga);

const replaceHostDomain = (uri, hostDomain) => uri.replace(/^(https:\/\/)(.*.com)(\/.*)/g, `$1${hostDomain}$3`);
const onBeforeAppLoad = configJson => {
    const isDebugMode = configJson?.debugMode ?? false;
    if (isDebugMode) {
        const fetchCopy = window.fetch;
        window.fetch = async (requestUri, ...args) => {
            let uri = requestUri;
            if (requestUri.includes(configJson.authority)) {
                if (
                    requestUri.includes('/RegistrationTokens') ||
                    requestUri.includes('/.well-known/openid-configuration')
                ) {
                    uri = replaceHostDomain(requestUri, configJson.debugRedirect.sts);
                } else if (requestUri.includes('/api/users') || requestUri.includes('/api/roles')) {
                    uri = replaceHostDomain(requestUri, configJson.debugRedirect.userApi);
                } else if (requestUri.includes('/api')) {
                    uri = replaceHostDomain(requestUri, configJson.debugRedirect.stsApi);
                }
            }

            const result = await fetchCopy(uri, ...args);
            return result;
        };
    }
    const oidcUserManagerConfig = getOidcConfig(configJson, isDebugMode);
    core.initializeOidc(oidcUserManagerConfig);
};

const OidcErrorComponent = ({ oidcError }) => {
    useEffect(() => {
        // console.log('OIDC error:', oidcError);
        // window.location.href = '/';
    }, []);

    return <OidcError title="Authentication Failed" message={oidcError} />;
};

const options = {
    includeOidc: true,
    onBeforeAppLoad,
    oidcErrorComponent: OidcErrorComponent,
    screenComponent: <AppContainer />,
    loadingComponent: <AppLoader />,
    errorBoundaryComponent: ErrorBoundary,
    getDialog: getDialogFactory,
    getDrawer: getDrawerFactory,
};

export const renderAuthenticatedApp = () => {
    core.setTheme(colors.primary, colors.secondary);
    core.appEntryPoint(MODULE_ID, options);
};

/* async function enableMocking() {
    if (process.env.NODE_ENV !== 'development') {
        return;
    }
    const { worker } = await import('./mocks/browser');
    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start();
}

enableMocking().then(() => {
    renderAuthenticatedApp();
}); */
